module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"headline_1":"Climate contribution","headline_2":"in the total amount of","sub_headline":""},"de":{"headline_1":"Klimabeitrag","headline_2":"in Höhe von insgesamt","sub_headline":""}}')
  delete Component.options._Ctor
}
